import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-0 md:min-h-[80vh] flex flex-col overflow-hidden bg-tcp-pure-black pt-[24px] pb-[60px] md:py-16" data-id="element-40" data-mp="30lkbillaz9dr">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" data-id="element-41" data-mp="2rsh0sl21lamt">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-tcp-red blur-[150px] opacity-20" data-id="element-42" data-mp="2rqnvb9360wge" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[40%] h-[40%] rounded-full bg-tcp-dark-red blur-[120px] opacity-20" data-id="element-43" data-mp="3k9telqodwzs1" />
      </div>

      {/* Subtle grid pattern for texture */}
      <div className="absolute inset-0 z-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-44" data-mp="2be6tc816zmrc" />

      {/* Logo pinned to top */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="relative z-10 flex justify-center pt-6 pb-0" data-id="element-45" data-mp="2z26ix4mrp74c">
        <img src="https://cdn.magicpatterns.com/uploads/w43AdcKJxYSjvc2DnTJZr6/tcp-wholesale-logo.png" alt="The Christmas Palace Wholesale" className="w-[157px] md:w-[224px] object-contain" data-id="element-46" data-mp="335mdzwj6uzex" />
      </motion.div>

      <div className="container mx-auto px-6 relative z-10 max-w-5xl flex-1 flex pt-[10px] items-center justify-center" data-id="element-47" data-mp="38tl0bf19mdto">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="text-center flex flex-col items-center" data-id="element-48" data-mp="3dth4pfdvk79r">
          <motion.h1 variants={itemVariants} className="font-display md:text-7xl font-bold text-white mb-6 tracking-tight text-[32px]" data-id="element-49" data-mp="3mtm2cxt9nraq">
            Premium Holiday Décor <br className="hidden md:block" data-id="element-50" data-mp="lcnhvgzb5z3" />
            <span className="italic font-light text-gray-300" data-id="element-51" data-mp="kb8xh0r81cm">for</span>{' '}
            Designers & Retailers
          </motion.h1>

          <motion.p variants={itemVariants} className="md:text-xl text-gray-400 max-w-3xl mx-auto mb-10 text-[14px] font-[400]" data-id="element-52" data-mp="abpheeaoobhw">
            Trusted for 35 years. Get first access to the products, pricing, and
            allocation that sell out every season.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-col items-center gap-4" data-id="element-53" data-mp="23uxvlzon2yq1">
            <motion.a href="https://wholesale.thechristmaspalace.com/pages/apply" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02,
            boxShadow: '0 0 20px rgba(183, 29, 35, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} className="bg-tcp-red hover:bg-tcp-dark-red text-white px-8 py-4 rounded-sm font-medium transition-colors duration-300 uppercase tracking-wide text-[12px] inline-block" data-id="element-54" data-mp="1yujwx88xh14o">
              Apply For Your Wholesale Account
            </motion.a>
            <p className="text-sm text-gray-500 flex items-center gap-2" data-id="element-55" data-mp="28rol1dmc36o4">
              Create an account to unlock wholesale pricing. No obligation.
              $1,000 minimum order.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}